<template>
  <UApp>
    <CommonUINavbar hide-toggle />
    <div class="error">
      <h1 class="error__title">{{ errorInfo?.title || 'Error' }}</h1>
      <p class="error__message">{{ errorInfo?.message || 'Ha ocurrido un error.' }}</p>
      <UButton to="/" icon="mdi:arrow-left" label="Volver al inicio" size="xl" />
    </div>
  </UApp>
</template>

<script setup lang="ts">
  import type { NuxtError } from '#app';

  // props
  const props = defineProps<{ error: NuxtError }>();

  // computed
  const errorInfo = {
    404: {
      title: '404',
      message: 'La página que buscas no existe.',
    },
    401: {
      title: '401',
      message: 'No tienes permisos para acceder a esta página.',
    },
    403: {
      title: '403',
      message: 'No tienes permisos para acceder a esta página.',
    },
    500: {
      title: '500',
      message: 'Ha ocurrido un error en el servidor.',
    },
  }[props.error.statusCode ?? 500];
</script>

<style scoped>
  @reference '~/assets/css/main.css';

  .error {
    @apply dark:bg-surface-900 flex h-[calc(100vh-10rem)] flex-col items-center justify-center gap-5 bg-white;
  }

  .error__title {
    @apply text-primary-1 dark:text-secondary-2 text-7xl font-bold;
  }

  .error__message {
    @apply dark:text-surface-200 font-light text-black;
  }
</style>
